import axios from 'axios';
import { loginreq } from './axiosFun';

// 图片上传
export const uploadImg = (params) => { return loginreq("post", "/uploadImg", params) };

// 单页获取
export const getCommonText = (params) => { return loginreq("get", "/home/getCommonText", params) };

// bannner
export const bannerList = (params) => { return loginreq("post", "/home/bannerList", params) };

// 首页
export const homeInfo = (params) => { return loginreq("post", "/home/homeInfo", params) };

// 注册接口 
export const register = (params) => { return loginreq("post", "/login/register", params) };

// 登录接口 
export const apiLogin = (params) => { return loginreq("post", "/login/apiLogin", params) };

// 获取手机验证码 
export const getPhoneCheckCode = (params) => { return loginreq("post", "/login/getPhoneCheckCode", params) };

// 获取邮箱验证码 
export const getEmail = (params) => { return loginreq("post", "/login/getEmail", params) };

// 忘记密码
export const forgetPass = (params) => { return loginreq("post", "/login/forgetPass", params) };

// 用户信息
export const userInfo = (params) => { return loginreq("post", "/user/userInfo", params) };

// 个人资料
export const editUserInfo = (params) => { return loginreq("post", "/user/editUserInfo", params) };

// 实名认证
export const certificate = (params) => { return loginreq("post", "/user/certificate", params) };

// 学校列表
export const collegeList = (params) => { return loginreq("post", "/user/collegeList", params) };

// 学校认证
export const collegeCertificate = (params) => { return loginreq("post", "/user/collegeCertificate", params) };

// 企业列表
export const companySearch = (params) => { return loginreq("post", "/user/companySearch", params) };

// 企业认证
export const companyCertificate = (params) => { return loginreq("post", "/user/companyCertificate", params) };

// 我的报名
export const mySignRecord = (params) => { return loginreq("post", "/user/mySignRecord", params) };

// 换绑手机号/邮箱
export const changeMobileBind = (params) => { return loginreq("post", "/user/changeMobileBind", params) };

// 修改密码
export const editPassword = (params) => { return loginreq("post", "/user/editPassword", params) };

// 我的证书列表
export const userCertList = (params) => { return loginreq("post", "/user/userCertList", params) };

// 我的证书详情
export const certInfo = (params) => { return loginreq("post", "/user/certInfo", params) };
export const userCertInfo = (params) => { return loginreq("post", "/user/userCertInfo", params) };

// 申请证书
export const applyCert = (params) => { return loginreq("post", "/user/applyCert", params) };

// 我的订单
export const myOrder = (params) => { return loginreq("post", "/user/myOrder", params) };

// 我的收藏
export const myCollectionList = (params) => { return loginreq("post", "/user/myCollectionList", params) };

// 我的优惠券
export const myCoupons = (params) => { return loginreq("post", "/user/myCoupons", params) };

// 领取优惠券
export const getCoupon = (params) => { return loginreq("post", "/user/getCoupon", params) };

// 获取公共列表
export const getCommonList = (params) => { return loginreq("post", "/home/getCommonList", params) };

// 科目列表
export const subjectList = (params) => { return loginreq("post", "/exam/subjectList", params) };

// 考试报名列表
export const examList = (params) => { return loginreq("post", "/exam/examList", params) };

// 考试报名详情
export const examInfo = (params) => { return loginreq("post", "/exam/examInfo", params) };

// 考试报名
export const examSign = (params) => { return loginreq("post", "/exam/examSign", params) };

// 开始考试
export const startExam = (params) => { return loginreq("post", "/exam/student/startExam", params) };

// 标记题目
export const pointQuestion = (params) => { return loginreq("post", "/exam/student/pointQuestion", params) };

// 保存答案
export const saveAnswer = (params) => { return loginreq("post", "/exam/student/saveAnswer", params) };

// 考试提交
export const examFinish = (params) => { return loginreq("post", "/exam/student/examFinish", params) };

// 获取考试结果
export const getExamResult = (params) => { return loginreq("post", "/exam/student/getExamResult", params) };

// 取消报名
export const signCancel = (params) => { return loginreq("post", "/exam/signCancel", params) };

// 考试轮次列表
export const lotList = (params) => { return loginreq("post", "/exam/lotList", params) };

// 重新预约
export const changeLot = (params) => { return loginreq("post", "/exam/changeLot", params) };

// 课程列表
export const courseList = (params) => { return loginreq("post", "/course/courseList", params) };

// 支付
export const examPay = (params) => { return loginreq("post", "/exam/examPay", params) };

// 激活优惠券
export const couponActive = (params) => { return loginreq("post", "/user/couponActive", params) };

// 激活优惠券
export const couponsList = (params) => { return loginreq("post", "/exam/couponsList", params) };

// 退款
export const refundOrder = (params) => { return loginreq("post", "/order/refundOrder", params) };

// 课程标签
export const labelList = (params) => { return loginreq("post", "/course/labelList", params) };

// 课程类型
export const typeList = (params) => { return loginreq("post", "/course/typeList", params) };

// 课程列表
export const courseLists = (params) => { return loginreq("post", "/course/courseList", params) };

// 课程详情
export const courseInfo = (params) => { return loginreq("post", "/course/courseInfo", params) };

// 课程报名
export const courseSign = (params) => { return loginreq("post", "/course/courseSign", params) };

// 课程视频
export const itemInfo = (params) => { return loginreq("post", "/course/itemInfo", params) };

// 课程支付
export const coursePay = (params) => { return loginreq("post", "/course/coursePay", params) };

// 我的课程
export const myCourse = (params) => { return loginreq("post", "/user/myCourse", params) };

// 发票申请
export const invoiceApply = (params) => { return loginreq("post", "/order/invoiceApply", params) };

// 收藏
export const collectCourse = (params) => { return loginreq("post", "/course/collectCourse", params) };

// 收藏
export const courseProcessSync = (params) => { return loginreq("post", "/course/courseProcessSync", params) };

// 支付详情
export const orderInfo = (params) => { return loginreq("post", "/order/orderInfo", params) };

// 申请优惠
export const couponApply = (params) => { return loginreq("post", "/user/couponApply", params) };

// 选择优惠券
export const editExamOrder = (params) => { return loginreq("post", "/exam/editExamOrder", params) };

// 意见反馈
export const Feedback = (params) => { return loginreq("post", "/home/Feedback", params) };

// 证书类型
export const certList = (params) => { return loginreq("post", "/cert/certList", params) };

// 证书查询
export const queryCert = (params) => { return loginreq("post", "/cert/queryCert", params) };

// 开课计划详情
export const planInfo = (params) => { return loginreq("post", "/course/planInfo", params) };

// 重新抽题
export const resetPractice = (params) => { return loginreq("post", "/exam/resetPractice", params) };

// 记录切屏次数
export const tabRecord = (params) => { return loginreq("post", "/exam/student/tabRecord", params) };

// 生成分享链接
export const getShare = (params) => { return loginreq("post", "/cert/share", params) };

// 查询证书链接
export const getCertUrl = (params) => { return loginreq("post", "/cert/certUrl", params) };


// WEBPACK FOOTER //
// ./src/api/userMG.js